import _ from "lodash"
import translate from "translations/global"
import moment from "moment"
import numeral from "numeral"
import settings from "settings"

export default {
	cleanZeroToNull: function (obj) {
		let f = {}
		_.forEach(obj, (v, k) => {
			if (v === 0) {
				f[k] = null
			} else {
				f[k] = v
			}
		})

		return f
	},
	bothUsers: function () {
		// Returns both the logged in admin as well as the salesperson they're viewing as.
		var jwtDecode = require("jwt-decode")
		let user = localStorage.getItem("user")
		let viewAs = localStorage.getItem("viewAs")

		user = jwtDecode(user)
		viewAs = viewAs ? jwtDecode(viewAs) : false

		return {
			sp: viewAs,
			admin: user,
		}
	},
	check(password) {
		let strength = {}
		const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})")
		const mediumRegex = new RegExp(
			"^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
		)
		if (strongRegex.test(password)) {
			strength = {
				id: 2,
				value: "Strong",
			}
		} else if (mediumRegex.test(password)) {
			strength = {
				id: 1,
				value: "Medium",
			}
		} else {
			strength = {
				id: 0,
				value: "Weak",
			}
		}
		return strength
	},
	submitClasses(f) {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	},
	translateObject(obj, translation) {
		let ret = {}
		_.forEach(translation, (v) => {
			if (obj.hasOwnProperty(v.name)) ret[v.english] = obj[v.name]
		})

		return ret
	},
	translateTable(data) {
		// This is for excel export.  Changes the key names, not values.
		let ret = []
		_.forEach(data, (row, index) => {
			_.forEach(row, (v, k) => {
				if (typeof v !== "object" || !v) {
					let find = _.find(translate, { name: k })
					let findEnglish = _.find(translate, { english: k })
					if (findEnglish) {
						return
					} // If this key is arlready in english format, then skip it as it's already good.
					if (find) {
						row[find.english] = row[k]
						delete row[k]
					} else {
						// else this takes something like percent_lot and translates to "Percent Lot" - in case we don't have a translation.
						let key = _.startCase(_.camelCase(k))
						// Sometimes key will be the same as k, and if so, this logic would set itself hten immediately delete, so make sure it's not the same.
						if (key !== k) {
							row[key] = row[k]
							delete row[k]
						}
					}
				} else if (v && typeof v == "object") {
					// sub groupings
					_.forEach(v, (sub, ik) => {
						let key = _.startCase(_.camelCase(k))
						let subKey = _.startCase(_.camelCase(ik))
						row[`${key} - ${subKey}`] = sub
					})
					delete row[k]
				}
			})
			ret.push(row)
		})
		return ret
	},
	humanReadableJSON(obj, pub, deleteObjects) {
		// Delete objects is for when you export and a field is an object, like arc_data, images, etc.  Excel export would have Image - 0, Image - 1 as columns.
		// takes in an array, outputs that array with human readable VALUES.  Keys should be done by translateTable above.
		_.forEach(obj, (r, key) => {
			_.forEach(r, (v, k) => {
				if (deleteObjects && typeof v == "object") {
					delete obj[key][k]
					return
				}
				// Check if it's a date
				if (typeof v == "number" && v > 946706400) {
					obj[key][k] = moment.unix(v).format("M/DD/YY")
					return
				}
				// NOw check in global translations to see if it's boolean or has a `public` lookup like lot types, properties, builders, etc.
				let look = _.find(translate, { name: k })
				if (!look) return
				if (look.boolean) {
					obj[key][k] = v ? "Yes" : "No"
					return
				}
				let pubLook = _.find(pub[look.id], { id: v })
				if (look.id && pubLook) {
					obj[key][k] = pubLook.name
				}
			})
		})
		return obj
	},
	stripHTML(string) {
		return string.replace(/(<([^>]+)>)/gi, "")
	},
	clean: function (obj) {
		for (const k in obj) {
			if (!obj[k]) {
				delete obj[k]
			}
		}

		return obj
	},
	cleanObject(obj) {
		let f = {}
		_.forEach(obj, (v, k) => {
			if (v && typeof v == "object") {
				f[k] = JSON.stringify(v)
			} else if (v && !isNaN(v)) {
				// a blank string with a space was messing this up like ' ' - the whitespace trimming above should resolve.
				if (Number.isInteger(v)) {
					f[k] = parseInt(v)
				} else {
					f[k] = parseFloat(v)
				}
			} else {
				f[k] = v
			}
		})
		return f
	},
	cleanArray(arr) {
		_.forEach(arr, (v, k) => {
			if (v && typeof v == "object") {
				arr[k] = JSON.stringify(v)
			} else if (v && !isNaN(v)) {
				if (Number.isInteger(v)) {
					arr[k] = parseInt(v)
				} else {
					arr[k] = parseFloat(v)
				}
			}
		})
		return arr
	},
	orderByLotType: (labels, data) => {
		let t = []
		_.forEach(labels, (v, k) => {
			t.push({
				name: v,
				total: data[k],
				numeric: parseInt(v.replace(/\D/g, "")),
			})
		})
		let sorted = _.sortBy(t, "numeric")
		let ret = {
			labels: [],
			data: [],
		}
		_.forEach(sorted, (v) => {
			ret.labels.push(v.name)
			ret.data.push(v.total)
		})
		return ret
	},
	orderByLotTypePoints: (data) => {
		// THis is used in segmentation point graphs.  The data that comes in is in the form of an object where the key is the type, like '28TH' or '40', and the value is an array of objects.  See segmentation.
		let orderedStorage = {}
		_.forEach(data, (v, k) => {
			orderedStorage[k] = {
				data: v,
				numeric: parseInt(k.replace(/\D/g, "")),
				name: k,
			}
		})

		orderedStorage = _.sortBy(orderedStorage, "numeric")
		let ordered = []
		_.forEach(orderedStorage, (v) => {
			ordered.push(v)
		})
		return ordered
	},
	sleep: (ms) => {
		return new Promise((resolve) => setTimeout(resolve, ms))
	},
	monthsBetween: (start, end) => {
		let moment = require("moment")
		// array of year/month combo between two dates.  dates passed should be timestamps
		let dateStart = moment.unix(start)
		let dateEnd = moment.unix(end)
		let interim = dateStart.clone()
		let timeValues = []

		while (dateEnd > interim || interim.format("M") === dateEnd.format("M")) {
			timeValues.push({
				year: interim.year(),
				yearShort: interim.format("YY"),
				month: interim.format("MMM"),
				fullMonth: interim.format("MMMM"),
				startStamp: interim.startOf("month").unix(),
				endStamp: interim.endOf("month").unix(),
			})
			interim.add(1, "month")
		}

		return timeValues
	},
	yearsBetween: (start, end) => {
		let startYear = moment.unix(start).year()
		let endYear = moment.unix(end).year()
		let ret = []
		for (let i = startYear; i <= endYear; i++) {
			ret.push(i)
		}
		return ret
	},
	isFloat(num) {
		return typeof num === "number" && !Number.isInteger(num)
	},
	cleanObjectNumbers(obj) {
		_.forEach(obj, (v) => {
			if (typeof v !== "number") {
				return
			}
			if (isNaN(v) || !isFinite(v)) {
				v = 0
			}
		})

		return obj
	},
	truncate(str, n) {
		if (str.length <= n) {
			return str
		}
		const subString = str.substr(0, n - 1) // the original check
		return subString.substr(0, subString.lastIndexOf(",")) + "..."
	},
	percentChange(a, b) {
		//return 100 * Math.abs((a - b) / ((a + b) / 2))
		return ((b - a) / a) * 100
	},
	dateFilter(f, r, format) {
		let date = moment.unix(r[f.id]).format(format || "MM/DD/YYYY")
		if (f.value === "!=") {
			if (!r[f.id]) return false
			else return true
		}
		if (typeof date == "string" && date.toLowerCase().includes(f.value.toLowerCase())) {
			return true
		}
	},
	safeBuilderName(builder) {
		return builder.replace(/[^\w- ]+/g, "")
	},
	tableDate(v, format) {
		let form = format || "M/DD/YY"
		if (v.value) {
			return moment.unix(v.value).format(form)
		}
		return ""
	},
	tableText(f, r, name) {
		let val = r[name]
		//if (!val) return false
		let query = f.value
		query = query ? query.toLowerCase() : ""
		if (typeof val == "number") {
			val = val.toString()
		}
		val = val && typeof val == "string" ? val.toLowerCase() : ""
		if (query.substr(0, 1) == "=") {
			// precise matching
			query = query.replace("=", "").toLowerCase()
			query = _.trim(query)
			if (query.includes(",")) {
				// multiple
				let queries = query.split(",")
				if (queries.includes(val)) return true
			} else {
				if (val == query) return true
			}
		} else if (query.substr(0, 2) == "!=") {
			// precise matching
			query = query.replace("!=", "").toLowerCase()
			query = _.trim(query)
			if (query.includes(",")) {
				// multiple
				let queries = query.split(",")
				if (!queries.includes(val)) return true
			} else {
				if (val !== query) return true
			}
		} else if (val.includes(query)) {
			// general fuzzy matching
			return true
		}
	},
	slugify(text) {
		return text
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "")
	},
	tableAverages(props, field, format, opts) {
		// opts has a dont divide for scenarios where we put a % in the format but dont want to divide the value by 100
		// format is for the numeral format
		let total = 0
		let count = 0
		_.forEach(props.data, (v) => {
			if (!v[field]) {
				return
			}
			total += v[field]
			count++
		})
		let f = total / count
		if (format.includes("%") && !_.get(opts, `dontDivide`)) {
			f = f / 100
		}
		let average = numeral(f).format(format)
		if (opts?.colored) {
			const formatted = numeral(f).format(format)
			if (Math.sign(f) == 1) {
				return <span className="darkGreen bold">{formatted}</span>
			} else if (Math.sign(f) == -1) {
				return <span className="red bold">{formatted}</span>
			} else {
				return 0
			}
		}
		return `${average}`
	},
	tableTotals(props, field, format, opts) {
		//? opts.lookatField is used in scenarios where the field is a react element like show red/green +-.  This allows us to look at a different field for the total.  See traffic week report.
		let total = 0
		_.forEach(props.data, (v) => {
			if (opts?.lookatField) {
				try {
					// values that aren't in the tables columns won't be in props.data's root, only in _original
					let orig = v?._original
					if (!orig) {
						console.log("table totals cant get orig for lookatfield")
					}
					if (orig[opts.lookatField] && typeof orig[opts.lookatField] === "number")
						total += orig[opts.lookatField]
				} catch (e) {
					console.log(e)
				}
			} else if (v[field] && typeof v[field] === "number") total += v[field]
		})
		return numeral(total).format(format)
	},
	hasNonNumericChars(str) {
		// if str has non-numeric chars, it will return true, else false
		return str.match(/[^$,.\d]/)
	},
	randomNum() {
		return _.random(0, 9999999)
	},
	trimObject(full, wanted) {
		// This is for cases whe nyou have an object like from post where you just want to pick out some of the properties and return that object.  Quicker than deleting or re-assigning
		let f = {}
		_.forEach(wanted, (v) => {
			f[v] = full[v]
		})
		return f
	},
	safeString(str) {
		return str.replace(/[^\w- ]+/g, "")
	},
	builderSwapColors(colors, labels, builders, type) {
		// colors is the colorArray, labels is just an array of builder names, builders is props.public.builders
		// colors and labels should be in the correct order....swapping keys
		// Type is variable - it can be exact match on builder name, or we can go through each builders and see if strings include builder names - e.g. Perry Homes vs Perry Home - 60'
		// returns colors
		try {
			if (type == "exact") {
				_.forEach(labels, (name, key) => {
					let lookup = _.find(builders, { name })
					if (lookup && lookup.color) colors[key] = lookup.color
				})
				return colors
			} else if (type == "search") {
				_.forEach(labels, (v, k) => {
					_.forEach(builders, (b, bk) => {
						if (typeof b.name == "string" && v.includes(b.name) && b.color) {
							colors[k] = b.color
						}
					})
				})
				return colors
			}
			return colors
		} catch (e) {
			console.log(e)
			return false
		}
	},
	isColorLight(color) {
		// Variables for red, green, blue values
		var r, g, b, hsp

		// Check the format of the color, HEX or RGB?
		if (color.match(/^rgb/)) {
			// If RGB --> store the red, green, blue values in separate variables
			color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

			r = color[1]
			g = color[2]
			b = color[3]
		} else {
			// If hex --> Convert it to RGB: http://gist.github.com/983661
			color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"))

			r = color >> 16
			g = (color >> 8) & 255
			b = color & 255
		}

		// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
		hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

		// Using the HSP value, determine whether the color is light or dark
		if (hsp > 127.5) {
			return true
		} else {
			return false
		}
	},
	lightenDarkenColor(col, amt) {
		try {
			let usePound = false
			if (col[0] == "#") {
				col = col.slice(1)
				usePound = true
			}
			let num = parseInt(col, 16)

			let r = (num >> 16) + amt

			if (r > 255) r = 255
			else if (r < 0) r = 0

			let b = ((num >> 8) & 0x00ff) + amt

			if (b > 255) b = 255
			else if (b < 0) b = 0

			let g = (num & 0x0000ff) + amt

			if (g > 255) g = 255
			else if (g < 0) g = 0

			return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16)
		} catch (e) {
			console.log(e)
		}
	},
	colorShade(col, amt) {
		col = col.replace(/^#/, "")
		if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]

		let [r, g, b] = col.match(/.{2}/g)
		;[r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt]

		r = Math.max(Math.min(255, r), 0).toString(16)
		g = Math.max(Math.min(255, g), 0).toString(16)
		b = Math.max(Math.min(255, b), 0).toString(16)

		const rr = (r.length < 2 ? "0" : "") + r
		const gg = (g.length < 2 ? "0" : "") + g
		const bb = (b.length < 2 ? "0" : "") + b

		return `#${rr}${gg}${bb}`
	},
	colorChange(hex, degree) {
		function randomizeHexColor(hexColor, degree) {
			// Convert the hex color string to an RGB color object
			const rgbColor = hexToRgb(hexColor)

			// Randomly adjust the RGB values
			const r = randomizeColorValue(rgbColor.r, degree)
			const g = randomizeColorValue(rgbColor.g, degree)
			const b = randomizeColorValue(rgbColor.b, degree)

			// Convert the adjusted RGB values back to a hex color string
			const adjustedHexColor = rgbToHex(r, g, b)

			return adjustedHexColor
		}

		function hexToRgb(hexColor) {
			// Remove the "#" character if it's present
			hexColor = hexColor.replace("#", "")

			// Convert the hex color string to an RGB color object
			const r = parseInt(hexColor.substring(0, 2), 16)
			const g = parseInt(hexColor.substring(2, 4), 16)
			const b = parseInt(hexColor.substring(4, 6), 16)

			return { r, g, b }
		}

		function rgbToHex(r, g, b) {
			// Convert the RGB values to a hex color string
			const hexR = r.toString(16).padStart(2, "0")
			const hexG = g.toString(16).padStart(2, "0")
			const hexB = b.toString(16).padStart(2, "0")

			return `#${hexR}${hexG}${hexB}`
		}

		function randomizeColorValue(value, degree) {
			// Generate a random number between 0 and degree
			const randomOffset = Math.floor(Math.random() * (degree + 1))

			// Determine whether to add or subtract the random offset
			const sign = Math.random() < 0.5 ? -1 : 1

			// Add the random offset to the original value
			let adjustedValue = value + sign * randomOffset

			// Make sure the adjusted value is within the valid range of 0 to 255
			adjustedValue = Math.max(0, Math.min(255, adjustedValue))

			return adjustedValue
		}
		if (!degree) degree = 40
		return randomizeHexColor(hex, degree)
	},
	randomColors() {
		// Returns an array of 100 random colors without duplicates.
		return Array.from({ length: 100 }, () => {
			const randomColor = Math.floor(Math.random() * 16777215).toString(16)
			return `#${randomColor}`
		}).filter((color, index, arr) => arr.indexOf(color) === index)
	},
	calculateLotPremium(lot) {
		// Some devs have lot premiums split out under local fields.  Check that first, and if not there, then fallback to the general "premium" field in the db.  This function sums up the broken out lot premiums via _.sum
		if (_.get(settings, `localFields.lotPremiums`)) {
			// this dev has premiums expanded
			let ret = []
			_.forEach(settings.localFields.lotPremiums, (v, k) => {
				try {
					if (v.type == "NumberField" && typeof lot.addl[k] == "number") {
						ret.push(lot.addl[k])
					}
				} catch (e) {
					console.log(e)
				}
			})
			ret = _.sum(ret)
			return ret
		} else {
			if (!lot.premium) return 0
			return parseFloat(lot.premium)
		}
	},
	twentyFourToTwelve(v) {
		let f = null
		if (v) {
			let arr = v.split(":")
			if (arr[0] > 12) {
				let h = arr[0] - 12
				f = `${h}:${arr[1]} PM`
			} else {
				if (arr[0] == "0" || arr[0] == "00") arr[0] = 12
				f = `${arr[0]}:${arr[1]} AM`
			}
		}

		return f
	},
	twelveToTwentyFour(v) {
		let f = null
		if (v) {
			try {
				let arr = v.split(":")
				let sec = arr[1].split(" ")
				if (v.includes("AM")) {
					if (arr[0] < 10) {
						f = `${arr[0]}:${sec[0]}`
					} else {
						f = `${arr[0]}:${sec[0]}`
					}
				} else {
					f = `${parseInt(arr[0]) + 12}:${sec[0]}`
				}
			} catch (e) {
				console.log(e)
			}
		}

		return f
	},
	internalCalendarTags() {
		return [
			{
				label: "Realtor",
				value: 1,
				color: "#58e875",
			},
			{
				label: "Marketing",
				value: 2,
				color: "#5883e8",
			},
		]
	},
	markerColors() {
		return {
			"Grocery Stores": "#FF0000",
			"Movie Theaters": "#a30b13",
			Restaurants: "#61a30b",
			Pools: "#3da6e3",
			Schools: "#a88f3b",
			Hospitals: "#b51825",
			Retail: "#b54c18",
			"Water Features": "#2ca3f2",
			Transportation: "#6516ab",
			Recreation: "#55a0e6",
			Entertainment: "#fc8c03",
			Parks: "#306900",
			Playground: "#31913e",
			"Dog Park": "#916f31",
			Golf: "#58b536",
			"Fire Station": "#9c0b12",
			Library: "#c4842f",
		}
	},
	isBuilderVDL(lot, time) {
		// this takes in a lot record and returns true or false.  time is for if we're running reports to see if the lot was builder VDL at that time. IF NO TIME is set, it's live.
		// From peter - He would like the VDL to represent Builder VDL & Under Contract – Not Started.
		// Asked Matt from Caldwelll about his definition of VDL, he said it's anything thats owned by the builder that is dirt but NOT sold, so getting conflicting information.  I think I agree with Matt.
		//? Timed vs live may be different in cases where there's bad data, e.g. a lot that's complete but not started, or a lot that's taken down with no builer assignment maybe?
		//? 12/11/24 - took the requirement off for a lot to be taken down.  Only needs to be builder assigned to be considered builderVDL.
		if (!time) {
			// LIVE
			// dontknow about model desigation?
			if (lot.model) return false
			if (lot.builder && !lot.start_date && !lot.complete_date && !lot.sale_id) {
				if (settings.vdlRequireTakedown && !lot.takedown_date) return false // override for this developer - they require takedown & builder assignment to be considered builder VDL.  Typically it's just builder assignment.
				return true
			} else return false
		} else {
			// historical timed
			if (
				lot.takedown_date && // all lots that are vdl must have a takedown date
				!lot.sale_id &&
				time > lot.takedown_date && // takedown date has to be before today
				((lot.start_date && lot.start_date > time) || !lot.start_date) && // has a start date and the start date is before today OR no start date
				((lot.sale_date && lot.sale_date < time) || !lot.sale_date) && // has a sale and it's before today OR no sale
				!lot.model // not a model
			)
				return true
			else return false
		}
	},
	isSpec(lot) {
		if (!lot.sale_id && lot.start_date) return true
		else return false
	},
	saleStatus(v) {
		//? send in a lot record and get out a string with the sale status - model, closed, contract etc
		let sale_status = ""
		if (v.model == 1) {
			sale_status = "Model"
		} else if (v.closing_date) {
			sale_status = "Closed"
		} else if (!v.closing_date && v.sale_id) {
			sale_status = "Contract"
		} else if (v.lot_status == "Bustout") {
			sale_status = "Bustout"
		} else if (v.reserve_start_date && !v.sale_id) {
			sale_status = "Reserved"
		}

		return sale_status
	},
	buildStatus(v) {
		//? pass in a lot record and get a build status
		let build_status
		if (!v.takedown_date) {
			build_status = ""
		} else if (v.complete_date) {
			build_status = "Complete"
		} else if (v.start_date) {
			build_status = "Slab"
		} else {
			build_status = "Vacant"
		}

		return build_status
	},
	formatPhoneNumber(phone) {
		if (!phone) return ""
		return phone
			.replace(/\D/g, "")
			.replace(/(\d*)(\d{3})(\d{3})(\d{4})$/, (s, a, b, c, d) => `+${a} (${b}) ${c}-${d}`)
			.replace(/\+(1\b|\s)\s*/, "")
	},
	canadianProvinces() {
		return [
			{ label: "Alberta", value: "AB" },
			{ label: "British Columbia", value: "BC" },
			{ label: "Manitoba", value: "MB" },
			{ label: "New Brunswick", value: "NB" },
			{ label: "Newfoundland and Labrador", value: "NL" },
			{ label: "Nova Scotia", value: "NS" },
			{ label: "Ontario", value: "ON" },
			{ label: "Prince Edward Island", value: "PE" },
			{ label: "Quebec", value: "QC" },
			{ label: "Saskatchewan", value: "SK" },
		]
	},
	firstMondayOfYear(year) {
		// returns a moment
		let date = moment().year(year).month(0).date(1).day(8)
		if (date.date() > 7) date.day(-6)
		date = date.startOf("day")
		return date
	},
	lastMondayOfYear(year) {
		// returns moment
		return moment().year(year).endOf("year").startOf("isoWeek")
	},
	pipsyWeekAndYear(timestamp) {
		// take in a timestamp, spits out the Pipsy week and year
		let mo = moment.unix(timestamp)
		let week = mo.isoWeek()
		let year = mo.year()
		let firstMonday = this.firstMondayOfYear(year)
		//console.log(week, mo.month())
		// month is december, week is 1, so it's the earlier year and week should be 53
		if (week == 1 && mo.month() == 11) {
			week = 53
		}
		// isoweek is 53 (previous year), mont his january, so in pipsy this is week 0
		else if (week == 53 && mo.month() == 0) {
			week = 0
		} else if (week == 53 && mo.month() == 11) {
			week = 53
		} else if (week == 52 && mo.month() == 0) {
			week = 0
		} else if (week == 1 && mo.month() == 0 && timestamp < firstMonday.unix()) {
			//? I thought this would work, however go to the first week of 2019.  If Jan 1 - Jan 6 are week 0, then there's no week 1.  Week 2 per ISO standards is Jan 7 - 13
			// iso week is 1, month is january, and this is before the first monday of the year, therefor it's week 0
			//week = 0
		}

		return { week, year }
	},
	gaugeOptions(title) {
		let windowWidth = window.innerWidth
		let fontSize = "45px"
		if (windowWidth <= 1300) fontSize = "30px"
		return {
			colors: ["#293450"],
			plotOptions: {
				radialBar: {
					hollow: {
						margin: 0,
						size: "70%",
						background: "#1e3652",
					},
					track: {
						dropShadow: {
							enabled: true,
							top: 2,
							left: 0,
							blur: 4,
							opacity: 0.15,
						},
					},
					dataLabels: {
						name: {
							offsetY: -15,
							color: "#fff",
							fontSize: "14px",
						},
						value: {
							color: "#fff",
							fontSize,
							show: true,
						},
					},
				},
			},
			fill: {
				type: "gradient",
				gradient: {
					shade: "dark",
					type: "vertical",
					gradientToColors: ["#6c9fba"],
					stops: [0, 100],
				},
			},
			stroke: {
				lineCap: "round",
			},
			labels: [title],
			chart: {
				animations: {
					enabled: true,
					easing: "easeinout",
					speed: 800,
					animateGradually: {
						enabled: true,
						delay: 150,
					},
					dynamicAnimation: {
						enabled: true,
						speed: 350,
					},
				},
			},
		}
	},
	median(data, type) {
		// data is an array of objects, like lots or sales.  Type is like price, sqft, etc.
		if (data.length === 0) {
			return 0
		}
		// Extract prices and sort them in ascending order
		//const set = data.map((home) => home[type]).sort((a, b) => a - b)
		const set = []
		_.forEach(data, (v) => {
			if (!v[type]) return
			set.push(v[type])
		})
		set.sort((a, b) => a - b)

		const middleIndex = Math.floor(set.length / 2)

		if (set.length % 2 === 0) {
			// If even number of set, average the two middle values
			return (set[middleIndex - 1] + set[middleIndex]) / 2
		} else {
			// If odd number of set, return the middle value
			return set[middleIndex]
		}
	},
	listViewAsUsers(users, builders, activeProperties) {
		let ret = []
		// First add in salespeople
		let sps = []
		let arc = []
		let managers = []
		let superintendent = []
		_.forEach(users, (v) => {
			if (v.status == 0 || !v.builders) {
				return
			}
			// salesperson without builder portal access - eg internet user
			if (v.group == 13 && v.builder_portal !== 1) {
				return
			}
			let build = v.builders[0]
			if (!build) return
			let builderLookup = _.find(builders, { id: v.builders[0] })
			let builderName = builderLookup ? builderLookup.name : ""
			let label = `${v.first} ${v.last}`
			let text = label
			if (v.group === 13) {
				text = `${label} - Salesperson - ${builderName}`
			} else if (v.group === 2) {
				text = `${label} - Sales Manager - ${builderName}`
			} else if (v.group === 14) {
				text = `${label} - ARC - ${builderName}`
			} else if (v.group === 15) {
				text = `${label} - Superintendent - ${builderName}`
			}
			label = (
				<span>
					{label} <span className="dropdown__secondary">{builderName}</span>
				</span>
			)
			let inter = _.intersection(v.properties, activeProperties)
			if (inter.length > 0) {
				if (v.group == 13) {
					sps.push({
						value: v.id,
						label,
						text,
					})
				} else if (v.group == 2) {
					managers.push({
						value: v.id,
						label,
						text,
					})
				} else if (v.group == 14) {
					arc.push({
						value: v.id,
						label,
						text,
					})
				} else if (v.group == 15) {
					superintendent.push({
						value: v.id,
						label,
						text,
					})
				}
			}
		})
		sps = _.sortBy(sps, "text")
		managers = _.sortBy(managers, "text")
		arc = _.sortBy(arc, "text")
		superintendent = _.sortBy(superintendent, "text")
		if (sps.length > 0) {
			ret.push({
				label: "Salespeople",
				options: sps,
			})
		}
		if (managers.length > 0) {
			ret.push({
				label: "Sales Managers",
				options: managers,
			})
		}
		if (arc.length > 0) {
			ret.push({
				label: "ARC",
				options: arc,
			})
		}
		if (superintendent.length > 0) {
			ret.push({
				label: "Superintendent",
				options: superintendent,
			})
		}

		return ret
	},
	levenshteinDistance(str1, str2) {
		str1 = str1.toLowerCase()
		str2 = str2.toLowerCase()
		const m = str1.length
		const n = str2.length
		const dp = Array(m + 1)
			.fill()
			.map(() => Array(n + 1).fill(0))

		for (let i = 0; i <= m; i++) {
			dp[i][0] = i
		}

		for (let j = 0; j <= n; j++) {
			dp[0][j] = j
		}

		for (let i = 1; i <= m; i++) {
			for (let j = 1; j <= n; j++) {
				if (str1[i - 1] === str2[j - 1]) {
					dp[i][j] = dp[i - 1][j - 1]
				} else {
					dp[i][j] = Math.min(
						dp[i - 1][j] + 1, // deletion
						dp[i][j - 1] + 1, // insertion
						dp[i - 1][j - 1] + 1 // substitution
					)
				}
			}
		}
		return dp[m][n]
	},
	stringSimilarity(str1, str2) {
		if (!str1 || !str2) return 0
		str1 = String(str1).toLowerCase()
		str2 = String(str2).toLowerCase()
		const distance = this.levenshteinDistance(str1, str2)
		const maxLength = Math.max(str1.length, str2.length)
		return ((maxLength - distance) / maxLength) * 100
	},
	snakeToTitle(snakeStr) {
		// roof_color to Roof Color
		return snakeStr
			.split("_")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ")
	},
	isFieldRequired(schema, field, context = {}) {
		const fieldSchema = schema.fields[field]
		if (!fieldSchema) {
			console.log(`Field "${field}" not found in schema`)
			return false
		}

		// Resolve schema using the current context for Yup 'when' conditional logic
		const resolvedSchema = fieldSchema.resolve(context)

		// Check if the resolved schema contains a 'required' test
		const isRequired = resolvedSchema.tests.some((test) => test.OPTIONS.name === "required")

		return isRequired
	},
	outputRequiredAsterix(schema, field, context) {
		// Returns an asterix if a field is required
		return this.isFieldRequired(schema, field, context) ? <sup>*</sup> : ""
	},
	calculateWeekEndDates(year) {
		//? This function will give you the week end dates for any year, week 0 and 53 crap figured out.  Tested on 2023 - 2026.  Can add further details to result if you need, like week start, timestamps, etc.
		const result = {}
		const startOfYear = moment(`${year}-01-01`)
		const endOfYear = moment(`${year}-12-31`)

		// Find the first Monday of the year
		let firstMonday = startOfYear.clone().day(1)
		if (firstMonday.year() < year) {
			firstMonday.add(1, "week")
		}

		// Handle Week 0 if necessary
		if (firstMonday.isAfter(startOfYear)) {
			result[0] = {
				weekEndDate: firstMonday.clone().subtract(1, "day").format("DD-MMM"),
			}
		}

		// Calculate weeks starting from the first Monday
		let currentWeek = firstMonday.clone()
		let weekNumber = 1

		while (currentWeek.isSameOrBefore(endOfYear)) {
			const weekEnd = currentWeek.clone().add(6, "days")

			if (weekEnd.isAfter(endOfYear)) {
				weekEnd.year(year).month(11).date(31) // Set to December 31st
			}

			result[weekNumber] = {
				weekEndDate: weekEnd.format("DD-MMM"),
			}

			currentWeek.add(1, "week")
			weekNumber++
		}

		return result
	},
	getIsoWeeksInMonth(year, month) {
		const startOfMonth = moment([year, month - 1])
		const endOfMonth = moment(startOfMonth).endOf("month")

		const firstWeek = startOfMonth.isoWeek()
		const lastWeek = endOfMonth.isoWeek()

		// Handle year boundary case (December-January transition)
		if (lastWeek < firstWeek) {
			// If the month spans across years, count weeks until year end and add weeks from new year
			const weeksInCurrentYear = moment([year, 11, 31]).isoWeek() - firstWeek + 1
			return weeksInCurrentYear + lastWeek
		}

		return lastWeek - firstWeek + 1
	},
	objectDiff(obj1, obj2) {
		let skip = ["addedDate", "action"]
		// Handle cases where either object is null/undefined
		if (!obj1 || !obj2) {
			if (obj1 === obj2) return {}
			return { old: obj1, new: obj2 }
		}

		// Handle non-object types
		if (typeof obj1 !== "object" || typeof obj2 !== "object") {
			if (obj1 === obj2) return {}
			return { old: obj1, new: obj2 }
		}

		// Handle arrays
		if (Array.isArray(obj1) && Array.isArray(obj2)) {
			if (obj1.length !== obj2.length) {
				return { old: obj1, new: obj2 }
			}

			const arrayDiffs = {}
			let hasDiffs = false

			for (let i = 0; i < obj1.length; i++) {
				const elementDiff = this.objectDiff(obj1[i], obj2[i])
				if (Object.keys(elementDiff).length > 0) {
					arrayDiffs[i] = elementDiff
					hasDiffs = true
				}
			}

			return hasDiffs ? arrayDiffs : {}
		}

		const differences = {}

		// Compare all keys in both objects
		const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)])

		for (const key of allKeys) {
			if (skip.includes(key)) continue
			// Handle cases where a key exists in one object but not the other
			if (!(key in obj1)) {
				if (!obj2[key]) continue // Skip if both are falsy
				differences[key] = { old: undefined, new: obj2[key] }
				continue
			}
			if (!(key in obj2)) {
				if (!obj1[key]) continue // Skip if both are falsy
				differences[key] = { old: obj1[key], new: undefined }
				continue
			}

			// Skip if both values are falsy
			if (!obj1[key] && !obj2[key]) continue

			// Recursively compare nested objects
			const valueDiff = this.objectDiff(obj1[key], obj2[key])
			if (Object.keys(valueDiff).length > 0) {
				differences[key] = valueDiff
			}
		}

		return differences
	},
	isDirtOrSpec(sale_date, start_date) {
		if (sale_date && start_date && sale_date >= start_date) return "Spec"
		else if (sale_date && !start_date) return "Dirt"
		else if (sale_date && start_date && sale_date < start_date) return "Dirt"
		return ""
	},
	selectARCColors(colors) {
		if (Array.isArray(colors)) {
			colors = _.filter(colors, (v) => v.status !== 0)
			return colors
				.map((v) => ({
					label: v.brand ? `${v.brand} - ${v.name}` : v.name,
					value: v.id,
				}))
				.sort((a, b) => a.label.localeCompare(b.label))
		}
		console.log('No Colors in "selectARCColors"')
		return []
	},
	arcFields() {
		/// This returns an array of all the ARC fields
		let ret = [
			"brick",
			"brick_material",
			"siding",
			"stucco",
			"trim",
			"door_color",
			"garage_color",
			"stone",
			"siding_type",
			"accent_color",
			"roof_color",
		]
		// Add custom fields here
		return ret
	},
	arcColorTypes() {
		// maybe custom settings here.
		return ["door_color", "garage_color", "trim", "siding", "stucco", "accent_color", "brick"]
	},
	outputMaterial(name, val, pub) {
		let v = parseInt(val)
		if (!v) return val
		let colors = this.arcColorTypes()
		if (colors.includes(name)) {
			let l = _.find(pub.arc_colors, { id: parseInt(val) })
			if (l) return l.name
		} else {
			let l = _.find(pub.arc_materials, { id: parseInt(val) })
			if (l) return l.name
		}
		return val
	},
	translateIdsToNames(data, pub) {
		// this function takes an object, finds property names thare in public, and if they're an integer, then it probably means we need to translate, which is what this does.
		//? This also translates timeestamps to dates
		_.forEach(data, (v, k) => {
			let translated = _.find(translate, { name: k })
			if (translated) {
				if (typeof v == "number") {
					let l = _.find(pub[k], { id: parseInt(v) })
					if (l) data[k] = l.name
				} else if (_.has(v, "previous") && _.has(v, "current")) {
					if (typeof v.current === "number" && v.current > 946706400) {
						//? This is a timestamp, so convert to date
						let d = moment.unix(v.current).format("MM/DD/YYYY")
						if (d) data[k].current = d
					}
					if (typeof v.previous === "number" && v.previous > 946706400) {
						//? This is a timestamp, so convert to date
						let d = moment.unix(v.previous).format("MM/DD/YYYY")
						if (d) data[k].previous = d
					}
				} else if (_.has(v, "previous") && _.has(v, "current")) {
					//? This was originally developed for the lot log to do this automatically.
					let l = _.find(pub[translated.id], { id: parseInt(v.current) })
					if (l) data[k].current = l.name
					l = _.find(pub[translated.id], { id: parseInt(v.previous) })
					if (l) data[k].previous = l.name
				}
			}
			//? now this is date translations
			else if (typeof v === "number" && v > 946706400) {
				//? This is a timestamp, so convert to date
				let d = moment.unix(v).format("MM/DD/YYYY")
				if (d) data[k] = d
			}

			//? This is for the lot log, where we have a previous and current value
			else if (_.has(v, "previous") && _.has(v, "current")) {
				//? Number date timestamp check first
				if (typeof v.current === "number" && v.current > 946706400) {
					//? This is a timestamp, so convert to date
					let d = moment.unix(v.next).format("MM/DD/YYYY")
					if (d) data[k].next = d
				}
				if (typeof v.previous === "number" && v.previous > 946706400) {
					//? This is a timestamp, so convert to date
					let d = moment.unix(v.previous).format("MM/DD/YYYY")
					if (d) data[k].previous = d
				}
			}
		})
		return data
	},
}
